module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1019-5d5d8c9cfc22b5d45534dcbbf5c2d3b0.png";